<template>
    <div class="card rounded-card mb-2 shadow-lg animate__animated animate__fadeIn animate__delay-1s">
        <router-link :to="{ name: 'independentsProfilePage', params: { id: freelancer.users_id } }" class="card-link">
            <div class="card-header border-0 pb-0">
                <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                        <div class="avatar me-2">
                            <img class="avatar-img rounded-circle" :src="freelancer.users_image
                                ? `https://zadcodeonline.com/ahmad/etqan/backEnd/upload/profile/${freelancer.users_image}`
                                : 'assets/person.png'" alt="Profile" />
                        </div>
                        <div class="me-2 d-flex align-items-center justify-content-between">
                            <div>
                                <p style="font-weight: bold;color: #296080;" class="text-person me-3 mb-0">{{
                                    freelancer.users_name }}</p>
                                <p class="text-person me-3 mb-0">{{ freelancer.categories_name }}</p>
                            </div>
                            <div class="me-4"></div>
                            <div class="rating d-flex align-items-center">
                                <i class="fas fa-star text-warning mx-1" v-for="star in 5" :key="star"
                                    :class="{ 'text-muted': star > freelancer.freelance_rating }"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <p class="mb-1">{{ freelancer.freelance_competence }}</p>
                <p class="mb-1">{{ freelancer.city_name }}</p>
                <p class="mb-1">{{ freelancer.freelance_personality }}</p>
            </div>
            <div class="row footerCard">
                <div class="d-flex justify-content-end">
                    <router-link style="background-color: #e1e8ed;" to="/chats" class="circle-btn me-1">
                        <i class="fas fa-paper-plane fs-2"></i>
                    </router-link>
                    <a href="#" style="background-color: #e1e8ed;" class="circle-btn me-1"
                        @click.prevent="toggleSave(freelancer.users_id)">
                        <i :class="isSaved ? 'fas fa-bookmark text-warning' : 'far fa-bookmark'"></i>                        <!-- <i :class="isSaved || freelancer.is_saves ? 'fas fa-bookmark text-warning' : 'far fa-bookmark'"></i> -->
                    </a>
                    <router-link style="background-color: #e1e8ed;" class="circle-btn me-1"
                        :to="{ path: '/request-service', query: { freelancer_id: freelancer.freelance_id, categories_name: freelancer.categories_name } }">
                        <i class="bi bi-file-earmark-text fs-2"></i>
                    </router-link>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
import axios from 'axios';


export default {
    name: "FreelancerCard",
    props: {
        freelancer: Object
    },
    data() {
        return {
            isSaved: this.freelancer.is_saves
        };
    },
    watch: {
        freelancer(newVal) { // تغيير من post إلى freelancer
            this.isSaved = newVal.is_saves;
        }
    },
    methods: {
        async toggleSave(freelancerId) {
            try {
                this.isSaved = !this.isSaved;

                const userId = localStorage.getItem("userId");
                if (!userId) {
                    alert("يجب تسجيل الدخول أولاً");
                    this.$router.push({ name: 'Login' });
                    return;
                }

                const response = await axios.post('https://zadcodeonline.com/ahmad/etqan/backEnd/posts/addordelete_save.php', {
                    postIdOrfreelancId: freelancerId,
                    typeadd: 2,
                    userId: userId
                },
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Accept': 'application/json'
                        },
                    });

                if (response.data.status === 'success') {
                    console.log(response.data);
                }
            } catch (error) {
                console.error('Error toggling save:', error);
            }
        },
    },
};
</script>

<style scoped>
.card-link {
    text-decoration: none;
    color: inherit;
    transition: transform 0.2s ease;
}

/* .card-link:hover {
    transform: scale(1.02);
} */

.footerCard {
    padding: 6px 0 15px 15px !important;
}

.card-body {
    padding: 10px 20px 0 20px !important;
}

.circle-btn {
    width: 60px;
    height: 60px;
    border: none;
    border-radius: 50%;
    color: #296080;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background-color 0.3s ease, transform 0.2s ease;
}

.circle-btn:hover {
    background-color: #f1995d;
    transform: scale(1.1);
}

.circle-btn i {
    font-size: 18px;
}

.card {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
    background-color: #faf9f8;
    border-radius: 25px !important;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
}

.card:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
}

.card-header {
    padding: 0.7rem !important;
    background-color: #faf9f8;
    border-radius: 15px;
}

.card-body p {
    font-size: 16px;
}

.animate__animated {
    animation-duration: 1s;
    animation-timing-function: ease-in-out;
}

.animate__fadeIn {
    animation-name: fadeIn;
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}
</style>